module.exports = __webpack_public_path__ + "static/media/uwy_logo.b1d22f04.svg";